module.exports = __webpack_public_path__ + "img/step4.f1624c87.png";